/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum ContractError {
  MissingDatapoints = 'missing-datapoints',
  InvalidForm = 'invalid-form',
  NoMaterialChanges = 'no-material-changes',
}

export enum AuthErrorCode {
  NoCookieHeader = 303,
  NoSessionIdInCookie = 304,
  NoCompanyIdHeader = 255,
  NoAliasIdHeader = 256,
  InvalidEmailFormatForUser = 100,
  InvalidUUIDFormatForCompanyId = 101,
  InvalidUUIDFormatForTeamId = 102,
  CouldNotReadFromSessionsDatabase = 200,
  SessionNotFound = 201,
  AliasIdMismatch = 234,
  CouldNotParseStateItem = 236,
  SessionExpiredWithAbsoluteTimeout = 202,
  SessionExpiredWithIdleTimeout = 203,
  InvalidAccessToken = 205,
  CouldNotRefreshToken = 204,
  CompanyIdNotFound = 106,
  CouldNotUpdateLastActiveTime = 299,
  CouldNotUpdateSessionsDatabase = 257,
  CouldNotReadFromAuthFlowDatabase = 103,
  CouldNotWriteToSessionsDatabase = 107,
  CouldNotSaveIntoAuthFlowDatabase = 102,
  NoStateFoundInAuthFlowDatabase = 111,
  NoSubOnToken = 666,
  UserEnrichmentFailed = 900,
  CouldNotDeleteSession = 110,
  CouldNotQuerySessionData = 108,
  MissingEnvVariables = 700,
  ExpiredToken = 701,
  MissingCompanyIdOrUserOnClient = 705,
  FailedToGetAuthRedirectUrl = 702,
  FailedToExchangeAuthCode = 703,
  FailedAuthWithoutServerCode = 704,
  NoAuthorizationHeader = 707,
  InvalidTokenRolesOrScopes = 722,
  TeamRolesMismatch = 723,
}
